module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar bgSubColor"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topbar-right"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    staticClass: "topbar-icon",
    attrs: {
      "type": "android-contact",
      "color": "#fff",
      "size": "30",
      "title": "登录"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": "/bookrack"
    }
  }, [_c('Icon', {
    staticClass: "topbar-icon",
    attrs: {
      "type": "ios-bookmarks",
      "color": "#fff",
      "size": "30",
      "title": "书架"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": "/search"
    }
  }, [_c('Icon', {
    staticClass: "topbar-icon",
    attrs: {
      "type": "android-search",
      "color": "#fff",
      "size": "30",
      "title": "搜索"
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0822405b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexTopbar.vue
// module id = 177
// module chunks = 1